import React, { useState } from 'react';

import { useRouter } from 'next/router';
import UseModal from 'hooks/use-modal';

import Modal from '@core/components/Modal/Modal';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import ActionButton from '@core/components/actionbutton/ActionButton';
import SubscriptionPaymentStepper from 'components/pages/plans/payment/subscriptionpaymentstepper/SubscriptionPaymentStepper';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { InfoCircle, TickCircle } from 'iconsax-react';

import TikIcon from 'assets/icons/tik-square-2.svg';

import classes from './CompareSection.module.scss';


const CompareSection = ({ data, isLoggedIn, toast }) => {

    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip placement='right-end' {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 16,
            padding: 15,

        },
    }));

    const router = useRouter();
    const [period, setPeriod] = useState('Annual');
    const { show, showModal, destroyModal } = UseModal(false);
    const selectPlanHandler = () => {
        if (isLoggedIn) {
            showModal();
        }
        else
            router.push('/login?next=' + router.asPath);
    };

    return (
        <>
            <div className='container'>
                <div className="row d-md-flex d-none justify-content-center">
                    <div className='col-12 col-xl-11 py-5'>
                        <table className={classes['tabl-comapre']}>
                            <thead>
                                <tr>
                                    <td><h1>Compare plans</h1></td>
                                    <td><div className={classes['free-title']}><h2>Free</h2></div></td>
                                    <td>
                                        <div className={classes['premium-title']}>
                                            <h2>Premium</h2>
                                            <ActionButton kind='secondary_main_light' onClick={selectPlanHandler}>
                                                Select Plan
                                            </ActionButton>
                                            <div className={classes['popular-badge']}>Most Popular</div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Courses & Learning
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Access Course Library
                                        <LightTooltip
                                            title="Access specialized courses designed by Experts to meet the unique needs of the pharmaceutical industry">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        Free Courses only
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Certifications
                                        <LightTooltip
                                            title="Earn shareable certificate of completion to demonstrate your newly acquired skills. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Downloadable Resources
                                        <LightTooltip
                                            title="Access extra resources designed to support your learning and career growth. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        For free courses
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Learn on mobile
                                        <LightTooltip
                                            title="Learn on the go with our intuitive mobile app, available on iOS and Android, giving you the freedom to study anytime, anywhere. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Career Preparation & Job Board
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Career Paths Access
                                        <LightTooltip
                                            title="Expertly chosen courses and tools to become an expert in your desired career.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Career Coaching
                                        <LightTooltip
                                            title="30-minute expert-led coaching sessions every month with our pharma expert.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        CV Builder
                                        <LightTooltip
                                            title="Create a standout resume with our CV Builder, effortlessly highlighting your skills and achievements for a professional edge.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Cover Letter Builder
                                        <LightTooltip
                                            title="Create a persuasive cover letter with our Cover Letter Builder, effortlessly highlighting your strengths and passion for the position. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Skill Tree
                                        <LightTooltip
                                            title="Visualize Your Progress. See how each completed course contributes to your overall skillset and identify areas for further growth.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        Limited
                                    </td>
                                    <td>
                                        Unlimited
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Personalized Profile URL
                                        <LightTooltip
                                            title="Get a personalized profile URL and build your brand as you advance your career. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Community
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Member-only Events
                                        <LightTooltip
                                            title="We invite our Pro members to exclusive events, such best practice workshops, Industry insights, software trends and more. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        LinkedIn Community
                                        <LightTooltip
                                            title="Gain access to a thriving community of Pharma experts from around the world to network, ask questions, and provide feedback. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                header={true}
            >
                <SubscriptionPaymentStepper
                    closeHandler={destroyModal}
                    toast={toast}
                    period={period}
                    setPeriod={setPeriod}
                />
            </Modal>
        </>
    );
};

export default CompareSection;